import React, { useState } from "react";
import { Box, TextField, Button, Typography } from "@mui/material";
import { colors } from "../../theme/colors";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import MzErrorText from "../../components/ui/MzErrorText";
import Api from "../../api/Api";
import { Urls } from "../../api/Urls";
function ResetPass() {
  const [errorLogin, setErroNotFound] = useState();
  const [success, setSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const validationSchema = yup.object().shape({
    Email: yup.string().email("entrer un email valide").required("ce champ est obligatoire"),
  });
  const formik = useFormik({
    initialValues: {
      Email: "",
    },
    validationSchema: validationSchema,
    onSubmit: () => {
      onSubmitSendOtpResetPassword();
    },
  });

  const onSubmitSendOtpResetPassword = () => {
    setIsLoading(true);
    setErroNotFound();
    setSuccess();

    Api.post(
      Urls.PASSWORD_RESET_OTP,
      {
        email: formik.values.Email,
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    )
      .then((res) => {
        if (res.status === 200) {
          console.log(res);
          toast.success(res?.data?.message);
          console.log(formik.values.email);
          navigate("/otp-mot-de-passe-oublier", { state: formik.values.Email });
        }
        setIsLoading(false);
      })
      .catch((err) => {
        if (err.response.status === 404) {
          setErroNotFound("Utilisateur introuvable");
        } else {
          setErroNotFound(err.response.data.message);
        }
        setIsLoading(false);
        if (err.response.status === 403) toast.error("Une erreur est survenue");
        else toast.error(err.response.data.message);
      });
  };
  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: `${colors.blue}` }} display="flex" alignItems="center" justifyContent="center">
      <ToastContainer />
      <Box sx={{ boxShadow: "0px 2px 5px 0px rgba(0,0,0,0.2)", padding: "2rem", background: "white", borderRadius: "15px", display: "flex", flexDirection: "column", gap: "0rem" }}>
        {" "}
        <Box display="flex" justifyContent="center" alignItems="center" marginTop="1rem">
          <Typography variant="text_md">Sendyo Board</Typography>
        </Box>
        <form onSubmit={formik.handleSubmit}>
          <Box margin="1rem 0rem" display="flex" alignItems="center" justifyContent="center" flexDirection="column" gap="2rem">
            <Box display="flex" flexDirection="column" gap="5px">
              <label>Email </label>
              <TextField type="email" name="Email" value={formik.values.Email} onChange={formik.handleChange} placeholder="Email" sx={{ width: { xs: "180px", lg: "300px", md: "300px", sm: "250px" } }} />
              {formik.errors.Email && formik.touched.Email && <MzErrorText>{formik.errors.Email}</MzErrorText>}
            </Box>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Button type="submit" disabled={isLoading} variant="primary">
              Récupérer mot de passe
            </Button>
          </Box>
        </form>
        {/* {errorLogin && <AlertError>{errorLogin}</AlertError>}
        {success && (
          <AlertSuccess sx={{ cursor: "pointer" }}>
            {success}{" "}
            <Typography onClick={() => navigate("/login")} sx={{ textDecoration: "underline", cursor: "pointer" }} fontSize="0.875rem" display="inline">
              Retournez vers Authentification
            </Typography>
          </AlertSuccess>
        )} */}
      </Box>
    </Box>
  );
}

export default ResetPass;
